module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/card-811b633592fc09091014f5be10c2672d.jpg";